import { DialogInfoBar } from "@components/common/dialog-info-bar";
import { useTranslate } from "@faro-lotv/foreign-observers";
import { companyCreditBalanceSelector } from "@store/sdb-company/sdb-company-selector";
import { useAppSelector } from "@store/store-helper";
import { formatNumber } from "@utils/data-display";

/** Renders the info bar for transactions dialog */
export function TransactionsInfoBar(): JSX.Element {
  const creditBalance = useAppSelector(companyCreditBalanceSelector);
  const translate = useTranslate();

  return (
    <DialogInfoBar
      items={[
        {
          label: "Balance",
          initialValue: formatNumber(creditBalance),
        },
        {
          label: "Period",
          initialValue: translate("All time"),
        },
      ]}
    />
  );
}
